module.exports = __webpack_public_path__ + "static/img/Hamilton.747efac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamilton.jpg
// module id = CDfV
// module chunks = 1